export const m0l0Solution = `%lang starknet


// TODO: add the Starknet file specifier at the beginning of the file


// do not modify code on this line or below

// All Starknet files must start with a specific line indicating the file is a smart contract,
// not just a regular Cairo file
func add(x: felt, y: felt) -> (res: felt) {
    return (res=x + y);
}

@view
func test_add() {
    add(1, 2);
    return();
}`;
